import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const PinIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.3285 2.97311C15.4113 1.05586 12.8622 0 10.1508 0C7.43947 0 4.8903 1.05586 2.9731 2.97311C1.05586 4.89039 0 7.43947 0 10.1508C0 15.6357 5.18618 20.1979 7.97239 22.6488C8.35958 22.9894 8.69394 23.2835 8.96033 23.5323C9.29408 23.8441 9.72247 24 10.1508 24C10.5792 24 11.0075 23.8441 11.3413 23.5323C11.6077 23.2835 11.942 22.9894 12.3292 22.6488C15.1154 20.1978 20.3016 15.6357 20.3016 10.1508C20.3015 7.43947 19.2457 4.89039 17.3285 2.97311ZM11.4006 21.5932C11.0049 21.9413 10.6633 22.2419 10.3815 22.505C10.2521 22.6258 10.0494 22.6259 9.91996 22.505C9.63829 22.2418 9.29657 21.9412 8.90089 21.5932C6.28151 19.289 1.40579 15 1.40579 10.1508C1.40579 5.32887 5.32872 1.40593 10.1507 1.40593C14.9727 1.40593 18.8956 5.32887 18.8956 10.1508C18.8957 15 14.02 19.289 11.4006 21.5932Z"
        fill="currentColor"
      />
      <path
        d="M10.1511 5.28906C7.68446 5.28906 5.67773 7.29574 5.67773 9.76236C5.67773 12.229 7.68446 14.2357 10.1511 14.2357C12.6177 14.2357 14.6244 12.229 14.6244 9.76236C14.6244 7.29574 12.6177 5.28906 10.1511 5.28906ZM10.1511 12.8297C8.45968 12.8297 7.08361 11.4537 7.08361 9.76231C7.08361 8.07096 8.45968 6.6949 10.1511 6.6949C11.8425 6.6949 13.2185 8.07096 13.2185 9.76231C13.2185 11.4537 11.8425 12.8297 10.1511 12.8297Z"
        fill="currentColor"
      />
    </svg>
  )
})

PinIcon.displayName = 'PinIcon'
